import React from 'react';
import { Col } from 'react-bootstrap';
import { LinkBtn } from '../../Utils/Button';
import Icon from '../../Icons';
import './LinkBtnDashboard.scss';

const LinkBtnDashboard = ({ role, to = '#', icon, text }) => {
  return (
    <>
      <Col sm={4} md={4} xs={12} className="mb-2">
        {role ? (
          <LinkBtn size="sm" block to={to} className="link-btn-dashboard">
            <Icon icon={icon} className="icon-15" /> {text}
          </LinkBtn>
        ) : (
          <LinkBtn size="sm" block to="#" className="link-btn-dashboard-disabled">
            <Icon icon="eye-off" className="icon-15" />
            Inactivo
          </LinkBtn>
        )}
      </Col>
    </>
  );
};

export default LinkBtnDashboard;
